import React from 'react';

import { useTableauEmbed } from '~/components/ReportsPage/EmbedComponents/useTableauEmbed';
import { useTableauEmbedRoutes } from '~/components/ReportsPage/Hooks/useTableauEmbedRoutes';
import type { TableauEmbedProps } from '~/components/ReportsPage/types';

export const TableauEmbedEditor: React.FC<TableauEmbedProps> = ({ workbook, view, token, options }) => {
  const { getEmbedUrl } = useTableauEmbedRoutes();
  const src = getEmbedUrl({ workbook, view });

  const ref = React.useRef(null);
  useTableauEmbed({ options, ref });

  return (
    <tableau-authoring-viz
      ref={ref}
      id="tableauAuthoringViz"
      src={src}
      token={token}
      hide-edit-in-desktop-button="true"
      show-share-options="false"
      suppress-default-edit-behavior="true"
      width={options.width}
      height={options.height}
    >
      <custom-parameter name=":embed" value="yes" />
      <custom-parameter name=":dataDetails" value="no" />
      <custom-parameter name=":customViews" value="no" />
      <custom-parameter name=":subscriptions" value="no" />
      <custom-parameter name=":alerts" value="no" />
      <custom-parameter name=":showShareOptions" value="false" />
    </tableau-authoring-viz>
  );
};
